export enum PipelineState {
  SUCCESS = 'success',
  FAILED = 'failed',
  RUNNING = 'running',
  QUEUED = 'queued',
}
